import type {
  CreateDraftProjectParams,
  DubbingDraft,
  ReformatDraft,
  RephrasingDraft,
  CaptionsDraft,
  UpdateDraftProjectParams,
  UpscaleDraft,
  AiAvatarDraft,
} from './types';

export enum Method {
  CREATE = 'create',
  UPDATE = 'update',
}

export const validateDubbingProject = (
  method: Method,
  params: CreateDraftProjectParams | UpdateDraftProjectParams
) => {
  const {draft} = params;
  const {dubbingSpecs} = draft as DubbingDraft;
  const errors: string[] = [];

  if (dubbingSpecs.length === 0) {
    errors.push('dubbingSpecs cannot be empty');
  }

  if (errors.length > 0) {
    console.error('Validation errors:', errors.join(', '));
  }
  return errors.length === 0;
};

export const validateReformatProject = (
  method: Method,
  params: CreateDraftProjectParams | UpdateDraftProjectParams
) => {
  const {draft} = params;
  const {reformatSpecs} = draft as ReformatDraft;
  const errors: string[] = [];

  if (reformatSpecs.length === 0) {
    errors.push('reformatSpecs cannot be empty');
  }

  if (errors.length > 0) {
    console.error('Validation errors:', errors.join(', '));
  }
  return errors.length === 0;
};

export const validateUpscaleProject = (
  method: Method,
  params: CreateDraftProjectParams | UpdateDraftProjectParams
) => {
  const {draft} = params;
  const {upscaleSpecs} = draft as UpscaleDraft;
  const errors: string[] = [];

  if (upscaleSpecs.length === 0) {
    errors.push('upscaleSpecs cannot be empty');
  }

  if (errors.length > 0) {
    console.error('Validation errors:', errors.join(', '));
  }
  return errors.length === 0;
};

export const validateRephrasingProject = (
  method: Method,
  params: CreateDraftProjectParams | UpdateDraftProjectParams
) => {
  const {draft} = params;
  const {rephrasingSpec} = draft as RephrasingDraft;
  const errors: string[] = [];

  if (!rephrasingSpec || !rephrasingSpec?.assetId) {
    errors.push('rephrasingSpec cannot be empty or missing assetId');
  }

  if (errors.length > 0) {
    console.error('Validation errors:', errors.join(', '));
  }
  return errors.length === 0;
};

export const validateCaptionsProject = (
  method: Method,
  params: CreateDraftProjectParams | UpdateDraftProjectParams
) => {
  const {draft} = params;
  const captionsDraft = draft as CaptionsDraft;
  const errors: string[] = [];

  if (!captionsDraft) {
    errors.push('captionsDraft cannot be empty');
    return false;
  }

  if (!captionsDraft.assetId) {
    errors.push('assetId is required');
  }

  if (!captionsDraft.style) {
    errors.push('style is required');
  }

  if (errors.length > 0) {
    console.error('Validation errors:', errors.join(', '));
  }
  return errors.length === 0;
};

export const validateAiAvatarProject = (
  method: Method,
  params: CreateDraftProjectParams | UpdateDraftProjectParams
) => {
  const {draft} = params;
  const {assetId, scriptData, avatarSpec} = draft as AiAvatarDraft;

  const errors: string[] = [];

  if (!assetId) {
    errors.push('assetId is required');
  }

  if (!scriptData) {
    errors.push('scriptData is required');
  } else if (scriptData && method === Method.UPDATE) {
    if (!Array.isArray(scriptData.scripts) || scriptData.scripts.length === 0) {
      errors.push('scriptData.scripts must be a non-empty array');
    }
    if (typeof scriptData.selectedScriptIndex !== 'number') {
      errors.push('scriptData.selectedScriptIndex must be a number');
    }
  }

  if (!avatarSpec) {
    errors.push('avatarSpec is required');
  }

  if (errors.length > 0) {
    console.error('Validation errors:', errors.join(', '));
    return false;
  }
  return true;
};
